import axios from "axios";

const axiosConfig = axios.create({
  baseURL: "https://api.bookybook.se/",
  withCredentials: true,
});

export default axiosConfig;
